import atlanta from './atlanta';
import austin from './austin';
import baltimore from './baltimore';
import boston from './boston';
import charlotte from './charlotte';
import chicago from './chicago';
import dallas from './dallas';
import dc from './dc';
import denver from './denver';
import detroit from './detroit';
import houston from './houston';
import la from './la';
import las_vegas from './las_vegas';
import miami from './miami';
import minneapolis from './minneapolis';
import nashville from './nashville';
import nyc from './nyc';
import orlando from './orlando';
import philadelphia from './philadelphia';
import phoenix from './phoenix';
import pittsburgh from './pittsburgh';
import portland from './portland';
import riverside from './riverside';
import sacramento from './sacramento';
import san_diego from './san_diego';
import san_francisco from './san_francisco';
import sanjose from './sanjose';
import seattle from './seattle';
import st_louis from './st_louis';
import tampa from './tampa';
import san_antonio from './san_antonio';

export const cities = {
    atlanta,
    austin,
    baltimore,
    boston,
    charlotte,
    chicago,
    dallas,
    detroit,
    dc,
    denver,
    houston,
    la,
    las_vegas,
    miami,
    minneapolis,
    nashville,
    nyc,
    orlando,
    philadelphia,
    phoenix,
    pittsburgh,
    portland,
    riverside,
    sacramento,
    san_diego,
    san_francisco,
    sanjose,
    seattle,
    st_louis,
    tampa,
    san_antonio,
};
